var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6 6V0h2v6h6v2H8v6H6V8H0V6h6z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }